import { type SubmitEvent, useId, useState } from 'react';
import { useNavigate } from 'react-router';
import { useI18n } from '../../lib/i18n/runtime';

/** Workspace-wide search box in the header; results open on the Search page. */
export function HeaderSearch({ workspaceId }: { workspaceId: string }) {
  const { t } = useI18n();
  const id = useId();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  function submit(event: SubmitEvent) {
    event.preventDefault();
    const q = query.trim();
    void navigate(
      q === '' ? `/w/${workspaceId}/search` : `/w/${workspaceId}/search?q=${encodeURIComponent(q)}`,
    );
    setQuery('');
  }

  return (
    <form
      role="search"
      className="header-search"
      onSubmit={submit}
      aria-label={t('workspaceSearch')}
    >
      <label htmlFor={id} className="visually-hidden">
        {t('headerSearchLabel')}
      </label>
      <input
        id={id}
        type="search"
        className="input input--compact"
        placeholder={t('searchPlaceholder')}
        value={query}
        maxLength={200}
        onChange={(event) => {
          setQuery(event.target.value);
        }}
      />
      <button type="submit" className="button button--small">
        {t('navSearch')}
      </button>
    </form>
  );
}
